module.exports = __webpack_public_path__ + "static/media/cert_101.f2f47404.jpg";